import React from "react";
import { jsx, css } from "@emotion/react";
import CardsGroupHeader, {
  TCardsGroupHeaderProps,
} from "./_cards-group-header";
import ConditionalRender from "../../../../shared/components/conditional-renderer";

type TProps = TCardsGroupHeaderProps;

function CardsGroup(props: TProps) {
  return (
    <div css={styles.container}>
      <CardsGroupHeader {...props} />
      <ConditionalRender
        condition1={!props.isCollapsed}
        renderIf1True={<ul css={styles.list}>{props.children}</ul>}
      />
    </div>
  );
}

export default CardsGroup;

const styles = {
  container: css`
    margin-bottom: 8px;
  `,
  list: css`
    margin: 8px 0 0 8px;
    & > * {
      margin-top: 8px;
    }
  `,
};
